import request from "@/utils/request.js"

// 账号密码登录
export function accountLoginApi(data){
  return request({
  	  method:'POST',
  	  url:'/aohua.account/login',
  	  data:data
  })
}
// 普通会员注册
export function registerApi(data){
  return request({
  	  method:'POST',
  	  url:'/aohua.account/register',
  	  data:data
  })
}
// 经销商扫码注册
export function scanRegisterApi(data){
  return request({
  	  method:'POST',
  	  url:'/aohua.account/scanRegister',
  	  data:data
  })
}
// 邮箱激活（GET）
export function verifyEmailApi(params){
  return request({
  	  method:'GET',
  	  url:'/aohua.account/verifyEmail',
  	  params:params
  })
}
// 重发激活邮件
export function resendActivationApi(data){
  return request({
  	  method:'POST',
  	  url:'/aohua.account/resendActivation',
  	  data:data
  })
}
// 产品型号下拉(匿名)
export function getProductListApi(){
  return request({
  	  method:'POST',
	  url:'/aohua.product_model/list',
	  data:{}
  })
}

// 图形验证码
export function getCaptchaApi(){
  return request({
	  method:'POST',
	  url:'/aohua.account/captcha',
	  data:{}
  })
}
